import { v4 } from 'uuid';

import reportExpose, { EReportExposeKey } from './report/reportExpose';

/**
 * @description: 获取 url query object
 * @param {string} url
 * @return {object}
 */
export function getQueryParams(url?: string): Record<string, string> {
  url = url || window.location.href;
  const queryIndex = url.indexOf('?');

  const queryParams = {};

  if (queryIndex !== -1) {
    const querySting = url.substring(queryIndex + 1);
    const pairs = querySting.split('&');

    for (const pair of pairs) {
      const [key, value] = pair.split('=');

      // @ts-expect-error any
      queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  }

  return queryParams;
}

/**
 * @description: 文件转base64编码
 * @param {File} file
 * @return {*}
 */
export function fileToBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}

/**
 * @description: 生成唯一标识符
 * @return {*}
 */
export function uuid(): string {
  return v4();
}

/**
 * @description: 首字母大写
 * @return {*}
 */
export function firstUpCase(str: string): string {
  return typeof str === 'string' ? `${str[0].toUpperCase()}${str.slice(1)} ` : '';
}

export function loadJs(url: string, key: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const headDom = document.head;
    const js = headDom.querySelector(`#${key}`);

    if (js) {
      return resolve(js);
    }

    const script = document.createElement('script');

    script.src = url;
    script.id = key;
    script.onload = () => {
      resolve(script);
    };
    script.onerror = (err) => {
      reject(err);
    };
    headDom.appendChild(script);
  });
}

export function trackMemory(params: { key3: string }): void {
  try {
    const memory = window.performance.memory;
    const memoryInfo = {
      jsHeapSizeLimit: memory.jsHeapSizeLimit,
      totalJSHeapSize: memory.totalJSHeapSize,
      usedJSHeapSize: memory.usedJSHeapSize,
      jsHeapSizePercent: (memory.usedJSHeapSize / memory.jsHeapSizeLimit).toFixed(2),
      href: window.location.href
    };
    const data = {
      key1: JSON.stringify(memoryInfo),
      key2: Date.now(),
      ...params
    };

    if (memory.usedJSHeapSize / memory.jsHeapSizeLimit > 0.1) {
      reportExpose(EReportExposeKey.memory_expose, data);
    }
  } catch {
    console.error('track-memory error');
  }
}

export function newLine2div(text: string): string {
  return text ? text.replaceAll('\n', '<div></div>') : '';
}
